var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.04 10.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.94,2.16c-.35-.5-.75-1-1.12-1.48-.17-.22-.36-.42-.5-.66-.03-.02-.09-.02-.11,0-.51.66-1.05,1.31-1.56,1.97-.03.04-.28.31-.23.35h.82s.05.03.06.04c.03.05-.02.1-.03.14-.42,2.02-1.64,3.83-3.24,5.09-1.71,1.35-3.9,2.1-6.02,2.45.2.02.4.05.59.09.02,0,.05,0,.07,0,2.81-.16,5.68-1.14,7.75-3.13,1.25-1.21,2.2-2.75,2.71-4.42.02-.07,0-.15.06-.21,0,0,.05-.04.06-.04h.8c0-.09-.06-.13-.1-.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteIcon);
export default __webpack_public_path__ + "static/media/logo_white_icon.e15dde55a18419cefb2002a14daa62f6.svg";
export { ForwardRef as ReactComponent };